goog.provide('yext.location.PhoneModel');
goog.provide('yext.location.Phone');

goog.require('yext');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');
goog.require('yext.location.Select');
goog.require('yext.location.helpers');

/**
 * Model for the phone field, which contains options
 *
 * @param {!Object}
 *
 * @constructor
 * @author Vincent Vuong (vvuong@yext.com)
 */
yext.location.PhoneModel = function(data) {
  this.country = data.country;
  this.number = data.number;
  this.displayNumber = data.displayNumber;
  this.indeterminate = data.indeterminate;
};

/**
 * Calls set and optionally triggers an update message
 *
 * @param {!Object} data Plain version of PhoneModel
 */
yext.location.PhoneModel.prototype.update = function(data) {
  if (this.set(data)) {
    this.message('updated');
  }
};

/**
 * Update country in model
 *
 * @param {string} value The updated value
 */
yext.location.PhoneModel.prototype.updateCountry = function(value) {
  if (yext.isString(value) && value != this.country) {
    this.country = value;
    this.emitUpdate();
  }
};

/**
 * Update number in model
 *
 * @param {string} value The updated value
 */
yext.location.PhoneModel.prototype.updateNumber = function(value) {
  if (yext.isString(value) && value != this.number) {
    this.number = value;
    this.emitUpdate();
  }
};

/**
 * Update the indeterminate flag on the model
 *
 * @param {boolean} indeterminate The updated value
 */
yext.location.PhoneModel.prototype.updateIndeterminate = function(indeterminate) {
  if (yext.isBoolean(indeterminate) && indeterminate !== this.indeterminate) {
    this.indeterminate = indeterminate;
    this.emitUpdate();
  }
};

/**
 * Update Phone model
 *
 * @param {PhoneModel}
 */
yext.location.PhoneModel.prototype.set = function(data) {
  var changed = false;

  if (this.country != data.country) {
    this.country = data.country;
    changed = true;
  }

  if (this.number != data.number) {
    this.number = data.number;
    changed = true;
  }

  if (this.displayNumber != data.displayNumber) {
    this.displayNumber = data.displayNumber;
    changed = true;
  }

  if (this.indeterminate != data.indeterminate) {
    this.indeterminate = data.indeterminate;
    changed = true;
  }

  return changed;
};

/**
 * Trigger a message on the PhoneModel
 *
 */
yext.location.PhoneModel.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * @param {!jQuery} $ctx Parent element for the field
 * @constructor
 */
yext.location.Phone = function($ctx) {
  this.$ctx = $ctx;
  this.$fieldValue = $ctx.find('.js-field-value');
  this.$phone = $ctx.find('.js-phone-field-edit');
  if (!this.$phone.length) {
    // This field is in view only mode
    return;
  }
  this.$inputField = $ctx.find('.js-phone-field-input');
  this.$phoneTable = $ctx.find('.js-phone-field-table');
  this.$indeterminateMsg = $ctx.find('.js-indeterminate-message-phone');

  this.countryCode = new yext.location.Select(this.$phone.find('.js-select-wrap'));
  this.parseDataFromDOM();
  this.storeValue();
  this.setFieldValue();
  this.bind();
  this.bindUpdates();
  this.render();
};

/**
 * Parse the initial data from the DOM
 */
yext.location.Phone.prototype.parseDataFromDOM = function() {
  var self = this;
  var data = this.$phone.data('value');
  this.timestamp = data.timestamp;
  this.countryCodes = {};
  this.defaultCountryCode = this.$phone.data('defaultCountryCode');

  this.model = new yext.location.PhoneModel({
    country: data['country'],
    number: data['number'],
    displayNumber: data['displayNumber'],
    indeterminate: data['indeterminate'],
  });
};

/**
 * Store the state for use in reset
 */
yext.location.Phone.prototype.storeValue = function() {
  this.storedModel = new yext.location.PhoneModel(this.model);
};

/*
 * Sets a hidden input to the JSON value of this field
 */
yext.location.Phone.prototype.setFieldValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.getJSONData()));
};

/**
 * Bind the country and input changes
 */
yext.location.Phone.prototype.bind = function() {
  var self = this;

  $(this.countryCode).on('updated', function() {
    self.model.updateCountry(self.countryCode.getValue());
  });

  this.$inputField.inputchange(function() {
    var $this = $(this);
    self.model.updateNumber($this.val());
  });

  this.$ctx.find('.js-reset-phone').click(function() {
    self.model.updateIndeterminate(false);
  });
};

/**
 * Listen for updates from the model and broadcasts an update message
 */
yext.location.Phone.prototype.bindUpdates = function() {
  var self = this;

  $(this.model).on('updated', function() {
    self.render();
    self.setFieldValue();
    self.emitUpdate();
  });
};

/**
 * Broadcast messages with the field as context
 *
 * @param {string} message Message to trigger
 */
yext.location.Phone.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * Reset the field to a stored state
 */
yext.location.Phone.prototype.reset = function() {
  this.set(this.storedModel);
};

/**
 * Set the model data
 *
 * @param {!Object} field Field data
 */
yext.location.Phone.prototype.set = function(field) {
  this.model.set(field);
  if (field.timestamp != null) {
    this.timestamp = field.timestamp;
  }
  this.render();
};

/**
 * Returns the display value as an HTML string for the field
 *
 * @return {string}
 */
yext.location.Phone.prototype.getDisplayValue = function() {
  if (this.model.number == '') {
    return yext.location.helpers.emptyFieldMessage();
  }

  var result = '';
  if (this.model.country != '') {
    result += this.countryCode.getDisplayValue();
  }
  result += ' ' + this.model.displayNumber;
  return result;
};

/**
 * Render the current state of the model
 */
yext.location.Phone.prototype.render = function() {
  this.$phoneTable.toggle(!this.model.indeterminate);
  this.$indeterminateMsg.toggle(this.model.indeterminate);

  this.$inputField.val(this.model.number);
  this.countryCode.set({
    value: this.model.country,
    displayValue: this.model.country,
  });
};

/**
 * Get the current state of the field as a JSON string
 *
 * @return {string} JSON string of field
 */
yext.location.Phone.prototype.getJSONData = function() {
  return {
    'country': this.model.country,
    'defaultCountryCode': this.defaultCountryCode,
    'number': this.model.number,
    'indeterminate': this.model.indeterminate,
    'timestamp': this.timestamp,
  };
};
